const DataLayer = class {
  static pushEvent(data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }
};

export default DataLayer;
